module.exports = "/legacy/4c04bd297e73f1f58da3ccc6039be4ce.svg";